module.exports = __webpack_public_path__ + "static/img/print_tela_treinamento.ffe9317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/print_tela_treinamento.png
// module id = KsMp
// module chunks = 0